export default "__VITE_ASSET__DpjbpboX__"